angular
    .module("skillBuilderSaaS")
    .directive("sbBusyIcon", function () {
    return {
        restrict: "A",
        scope: {
            sbBusyIcon: "@"
        },
        link: function (scope, element) {
            element.bind("click", function () {
                var icon = element.find("i");
                icon.attr("class", scope.sbBusyIcon);
            });
            //scope.$watch(() => {
            //	return element.context.disabled;
            //}, function (value) {
            //	element.context.firstElementChild.outerHTML = "<i class='" + (value ? scope.trueIcon : scope.falseIcon) + "'></i>";
            //});
        }
    };
});
